import { usText } from "./messages/en";
import { ptText } from "./messages/pt";
import { keysMessages } from './keysMessages';

export const systemMessages = {
    pt: ptText,
    us: usText,
    keysMessages
};